import { FaWhatsapp } from 'react-icons/fa'
import { HiOutlineMail } from 'react-icons/hi'

const data = [
    {id: 1, icon: <HiOutlineMail/>, link: 'mailto:bowman.marquice@gmail.com'},
    {id: 2, icon: <FaWhatsapp/>, link: 'https://wa.me/+12022225640'}
]

export default data